// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 37.4rem) {
  .style_hide-sm__nIxtG {
    display: none !important;
  }
}
@media (min-width: 37.4rem) {
  .style_visible-sm__Gn6tX {
    display: none !important;
  }
}
@media (max-width: 79.9rem) {
  .style_hide-md__zBbTY {
    display: none !important;
  }
}
@media (min-width: 79.9rem) {
  .style_visible-md__TGjbr {
    display: none !important;
  }
}
/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
.style_dataTable__mS0o1 {
  border-collapse: collapse;
  background-color: var(--colorBackgroundPrimaryDefault);
  width: 100%;
  font-size: 0.875rem;
  line-height: 1rem;
}
.style_dataTableHeader__Kgqow .style_dataTableRow__cdmbG {
  border-top: none;
}
.style_dataTableHeader__Kgqow .style_dataTableRow__cdmbG:hover,
.style_dataTableHeader__Kgqow .style_dataTableRow__cdmbG:focus {
  background-color: transparent;
}
.style_dataTableHeaderColumn__efA1W {
  color: var(--colorTextTertiary);
  padding: 0 1.125rem 0.75rem 1.125rem;
  line-height: 1rem;
  font-weight: 400;
  padding-bottom: 1rem;
  padding-top: 1rem;
  box-sizing: border-box;
}
.style_dataTableHeaderColumn__efA1W {
  text-align: left;
}
.style_dataTableRowHeaderColumn__i6Tvb {
  vertical-align: top;
  padding-top: 0.875rem;
  text-align: right;
  width: 16rem;
}
.style_dataTableRowHeaderColumnInSidebar__y6tDh {
  width: 8rem !important;
}
.style_dataTableFooterColumn__kXLO8 {
  color: var(--colorTextTertiary);
  padding: 0;
  line-height: 1rem;
  font-weight: 400;
  padding-bottom: 1rem;
  text-align: left;
  box-sizing: border-box;
}
.style_dataTableRow__cdmbG {
  border-top: 0.0625rem solid var(--colorBorderTertiary);
}
.style_dataTableRow__cdmbG:last-child {
  border-bottom: 0.0625rem solid var(--colorBorderTertiary);
}
.style_dataTableRow__cdmbG:hover,
.style_dataTableRow__cdmbG:focus {
  background-color: var(--colorBackgroundPrimaryHover);
}
.style_dataTableRow__cdmbG.style_noBorder__cVf9G {
  border: none;
}
.style_dataTableRow__cdmbG.style_noBorder__cVf9G:hover,
.style_dataTableRow__cdmbG.style_noBorder__cVf9G:focus {
  background-color: transparent;
}
.style_dataTableRow__cdmbG button:not([role]) {
  background-color: transparent !important;
  border: none !important;
}
.style_dataTableRow__cdmbG button:not([role]):hover {
  background-color: rgb(from currentcolor r g b / 0.08) !important;
}
.style_dataTableRow__cdmbG button:not([role]):active {
  background-color: rgb(from currentcolor r g b / 0.24) !important;
}
.style_dataTableRowColumn__QPWVm {
  box-sizing: border-box;
  color: var(--colorTextPrimary);
  vertical-align: top;
  padding: 0.875rem 1.125rem;
}
.style_dataTableRowColumn__QPWVm:first-child {
  font-weight: 500;
}
.style_dataTableRowWithActionColumn__i_Ypj {
  display: flex;
  flex-direction: row;
}
.style_dataTableRowWithActionColumnText__ynAdI {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
.style_dataTableRowWithActionColumnAction__QLxCX {
  display: flex;
  align-items: center;
  flex-basis: 15.625rem;
}
.style_dataTableRowColumn__QPWVm a {
  text-align: left;
  color: var(--colorTextLinkDefault);
}
@media (max-width: 37.4rem) {
  .style_dataTable__mS0o1,
  .style_dataTableHeader__Kgqow,
  .style_dataTableBody__x1lFx,
  .style_dataTableHeaderColumn__efA1W,
  .style_dataTableFooterColumn__kXLO8,
  .style_dataTableRow__cdmbG,
  .style_dataTableRowColumn__QPWVm {
    display: block;
  }
  .style_dataTable__mS0o1 {
    border: none;
  }
  /* Hide table headers (but not display: none;, for accessibility) */
  .style_dataTableHeader__Kgqow .style_dataTableRow__cdmbG:not(.style_dataTableToolsRow__rdfct) {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .style_dataTableRowColumn__QPWVm {
    border: none;
    position: relative;
    line-height: 1.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0;
    max-width: 100%;
  }
  .style_dataTableRowHeaderColumn__i6Tvb {
    padding: 0.875rem 1.125rem;
    text-align: left;
    width: unset;
  }
  .style_dataTableRowHeaderColumnInSidebar__y6tDh {
    width: unset;
  }
  .style_dataTableRowColumn__QPWVm:first-child,
  .style_dataTableRowColumn__QPWVm:not(:first-child) {
    width: 100%;
  }
  .style_dataTableRowColumn__QPWVm:not(:first-child) {
    padding-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./app/resources/styles/media.less","webpack://./app/components/DataTable/style.less"],"names":[],"mappings":"AAMA;EACE;IACE,wBAAA;ECLF;AACF;ADQA;EACE;IACE,wBAAA;ECNF;AACF;ADSA;EACE;IACE,wBAAA;ECPF;AACF;ADSA;EACE;IACE,wBAAA;ECPF;AACF;AACA;;;;;;;;;;;;EAYE;AA5BF;EACI,yBAAA;EACA,sDAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AA8BJ;AA3BA;EACI,gBAAA;AA6BJ;AA5BI;;EAEI,6BAAA;AA8BR;AA1BA;EACI,+BAAA;EACA,oCAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;AA4BJ;AAzBA;EACI,gBAAA;AA2BJ;AAxBA;EACI,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AA0BJ;AAvBA;EACI,sBAAA;AAyBJ;AAtBA;EACI,+BAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;AAwBJ;AArBA;EACI,sDAAA;AAuBJ;AAtBI;EACI,yDAAA;AAwBR;AAtBI;;EAEI,oDAAA;AAwBR;AAtBI;EACI,YAAA;AAwBR;AAvBQ;;EAEI,6BAAA;AAyBZ;AAtCA;EAiBQ,wCAAA;EACA,uBAAA;AAwBR;AAvBQ;EACI,gEAAA;AAyBZ;AAvBQ;EACI,gEAAA;AAyBZ;AApBA;EACI,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;AAsBJ;AArBI;EACI,gBAAA;AAuBR;AAnBA;EACI,aAAA;EACA,mBAAA;AAqBJ;AAlBA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAoBJ;AAjBA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;AAmBJ;AAhBA;EACI,gBAAA;EACA,kCAAA;AAkBJ;AAfA;EACI;;;;;;;IAOI,cAAA;EAiBN;EAfE;IACI,YAAA;EAiBN;EACA,mEAAmE;EAfjE;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EAiBN;EAfE;IACI,YAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,iBAAA;IACA,eAAA;EAiBN;EAfE;IACI,0BAAA;IACA,gBAAA;IACA,YAAA;EAiBN;EAfE;IACI,YAAA;EAiBN;EAfE;;IAEI,WAAA;EAiBN;EAfE;IACI,cAAA;EAiBN;AACF","sourcesContent":["//@screen-xs: 480px;\n@screen-sm: 37.4rem; //600px\n@screen-md: 79.9rem; //1279px\n//@screen-lg-min: 1280px;\n//@scree-xl-min: 1920px;\n\n@media (max-width: @screen-sm) {\n  .hide-sm {\n    display: none !important;\n  }\n}\n\n@media (min-width: @screen-sm) {\n  .visible-sm {\n    display: none !important;\n  }\n}\n\n@media (max-width: @screen-md) {\n  .hide-md {\n    display: none !important;\n  }\n}\n@media (min-width: @screen-md) {\n  .visible-md {\n    display: none !important;\n  }\n}","@import \"../../resources/styles/media\";\n@import \"../../resources/styles/colors\";\n@import \"../../resources/styles/variables\";\n\n.dataTable {\n    border-collapse: collapse;\n    background-color: @white;\n    width: 100%;\n    font-size: 0.875rem;\n    line-height: 1rem;\n}\n\n.dataTableHeader .dataTableRow {\n    border-top: none;\n    &:hover,\n    &:focus {\n        background-color: transparent;\n    }\n}\n\n.dataTableHeaderColumn {\n    color: @secondaryText;\n    padding: 0 1.125rem 0.75rem 1.125rem;\n    line-height: 1rem;\n    font-weight: @normal;\n    padding-bottom: 1rem;\n    padding-top: 1rem;\n    box-sizing: border-box;\n}\n\n.dataTableHeaderColumn {\n    text-align: left;\n}\n\n.dataTableRowHeaderColumn {\n    vertical-align: top;\n    padding-top: 0.875rem;\n    text-align: right;\n    width: 16rem;\n}\n\n.dataTableRowHeaderColumnInSidebar {\n    width: 8rem !important;\n}\n\n.dataTableFooterColumn {\n    color: @secondaryText;\n    padding: 0;\n    line-height: 1rem;\n    font-weight: @normal;\n    padding-bottom: 1rem;\n    text-align: left;\n    box-sizing: border-box;\n}\n\n.dataTableRow {\n    border-top: 0.0625rem solid @divider;\n    &:last-child {\n        border-bottom: 0.0625rem solid @divider;\n    }\n    &:hover,\n    &:focus {\n        background-color: @hover;\n    }\n    &.noBorder {\n        border: none;\n        &:hover,\n        &:focus {\n            background-color: transparent;\n        }\n    }\n    button:not([role]) {\n        background-color: transparent !important;\n        border: none !important;\n        &:hover {\n            background-color: rgb(from currentcolor r g b / 0.08) !important;\n        }\n        &:active {\n            background-color: rgb(from currentcolor r g b / 0.24) !important;\n        }\n    }\n}\n\n.dataTableRowColumn {\n    box-sizing: border-box;\n    color: @primaryText;\n    vertical-align: top;\n    padding: 0.875rem 1.125rem;\n    &:first-child {\n        font-weight: @semibold;\n    }\n}\n\n.dataTableRowWithActionColumn {\n    display: flex;\n    flex-direction: row;\n}\n\n.dataTableRowWithActionColumnText {\n    display: flex;\n    align-items: center;\n    flex-grow: 1;\n}\n\n.dataTableRowWithActionColumnAction {\n    display: flex;\n    align-items: center;\n    flex-basis: 250/16rem;\n}\n\n.dataTableRowColumn a {\n    text-align: left;\n    color: @primary\n}\n\n@media (max-width: @screen-sm) {\n    .dataTable,\n    .dataTableHeader,\n    .dataTableBody,\n    .dataTableHeaderColumn,\n    .dataTableFooterColumn,\n    .dataTableRow,\n    .dataTableRowColumn {\n        display: block;\n    }\n    .dataTable {\n        border: none;\n    }\n    /* Hide table headers (but not display: none;, for accessibility) */\n    .dataTableHeader .dataTableRow:not(.dataTableToolsRow) {\n        position: absolute;\n        top: -9999px;\n        left: -9999px;\n    }\n    .dataTableRowColumn {\n        border: none;\n        position: relative;\n        line-height: 1.5rem;\n        padding-top: 0.5rem;\n        padding-bottom: 0;\n        max-width: 100%;\n    }\n    .dataTableRowHeaderColumn {\n        padding: 0.875rem 1.125rem;\n        text-align: left;\n        width: unset;\n    }\n    .dataTableRowHeaderColumnInSidebar {\n        width: unset;\n    }\n    .dataTableRowColumn:first-child,\n    .dataTableRowColumn:not(:first-child) {\n        width: 100%;\n    }\n    .dataTableRowColumn:not(:first-child) {\n        padding-top: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hide-sm": `style_hide-sm__nIxtG`,
	"hideSm": `style_hide-sm__nIxtG`,
	"visible-sm": `style_visible-sm__Gn6tX`,
	"visibleSm": `style_visible-sm__Gn6tX`,
	"hide-md": `style_hide-md__zBbTY`,
	"hideMd": `style_hide-md__zBbTY`,
	"visible-md": `style_visible-md__TGjbr`,
	"visibleMd": `style_visible-md__TGjbr`,
	"dataTable": `style_dataTable__mS0o1`,
	"dataTableHeader": `style_dataTableHeader__Kgqow`,
	"dataTableRow": `style_dataTableRow__cdmbG`,
	"dataTableHeaderColumn": `style_dataTableHeaderColumn__efA1W`,
	"dataTableRowHeaderColumn": `style_dataTableRowHeaderColumn__i6Tvb`,
	"dataTableRowHeaderColumnInSidebar": `style_dataTableRowHeaderColumnInSidebar__y6tDh`,
	"dataTableFooterColumn": `style_dataTableFooterColumn__kXLO8`,
	"noBorder": `style_noBorder__cVf9G`,
	"dataTableRowColumn": `style_dataTableRowColumn__QPWVm`,
	"dataTableRowWithActionColumn": `style_dataTableRowWithActionColumn__i_Ypj`,
	"dataTableRowWithActionColumnText": `style_dataTableRowWithActionColumnText__ynAdI`,
	"dataTableRowWithActionColumnAction": `style_dataTableRowWithActionColumnAction__QLxCX`,
	"dataTableBody": `style_dataTableBody__x1lFx`,
	"dataTableToolsRow": `style_dataTableToolsRow__rdfct`
};
module.exports = ___CSS_LOADER_EXPORT___;
